import { LoadingPage } from "@/components/elements/Loading/Loading";
import { JobForm } from "@/features/job/components/JobForm";
import { TJobForm } from "@/features/job/types/JobForm";
import { initJobWorkingTimeForm } from "@/features/job/utils/convertJobFormData";
import { DEFAULT_ONBOARDING_SUPPORTS, YES_NO_PENDING_STATUS } from "@/types/enum";
import { showError } from "@/utils/error";
import { useEffect, useState } from "react";

export const JobCreatePage = () => {
  const [defaultValues, setDefaultValues] = useState<Partial<TJobForm> | undefined>(undefined);
  useEffect(() => {
    const key = "duplicated-job-data";
    const jobData = localStorage.getItem(key);
    if (jobData) {
      try {
        const parsedData = JSON.parse(jobData);
        setDefaultValues(parsedData);
        // Remove it after loading to avoid reusing it.
        localStorage.removeItem(key);
      } catch (e) {
        showError(e);
      }
    } else {
      setDefaultValues({});
    }
  }, []);

  if (!defaultValues) return <LoadingPage />;

  const initDefaultValues = {
    ...defaultValues,
    jobWorkingTimes: defaultValues?.jobWorkingTimes ?? [initJobWorkingTimeForm],
    bonus: defaultValues?.bonus ?? YES_NO_PENDING_STATUS.PENDING,
    salaryRaise : defaultValues?.salaryRaise ?? YES_NO_PENDING_STATUS.PENDING,
    onboardingSupport: defaultValues?.onboardingSupport ?? DEFAULT_ONBOARDING_SUPPORTS,
  };

  return <JobForm defaultValues={initDefaultValues} />;
};
